import React from 'react';
import MDEditor from '@uiw/react-md-editor';

interface MarkdownFieldProps {
  value?: string;
  onChange?: (value?: string) => void;
  height?: number;
  [key: string]: any;
}

export const MarkdownField: React.FC<MarkdownFieldProps> = ({
  value = '',
  onChange,
  height = 200,
  ...props
}) => {
  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px' }}>
      <MDEditor
        data-color-mode="light"
        preview="edit"
        height={height}
        value={value}
        onChange={onChange}
        {...props}
      />
    </div>
  );
};
